module.exports = __webpack_public_path__ + "static/media/bg_page3.af5d16ac.png";